import React from 'react';
import { Truck, DollarSign, Map, Clock } from 'lucide-react';
import { whyTruckingReasons } from '../mock';

const iconMap = {
  'High Demand Career': Truck,
  'Great Salary': DollarSign,
  'Travel & Adventure': Map,
  'Quick Training': Clock
};

export const WhyTrucking = () => {
  return (
    <section id="why-trucking" className="py-20 px-4 bg-white">
      <div className="container mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#1e3a5f] mb-4">
            Why Choose Trucking?
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Truck drivers are essential! Having a career in the commercial driving industry offers job stability, great income, and a lifestyle many love.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {whyTruckingReasons.map((reason) => {
            const Icon = iconMap[reason.title];
            return (
              <div 
                key={reason.title}
                className="group p-6 bg-gradient-to-br from-[#f0f9ff] to-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
              >
                <div className="w-14 h-14 bg-[#d97706] rounded-lg flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                  <Icon className="w-7 h-7 text-white" />
                </div>
                <h3 className="text-xl font-bold text-[#1e3a5f] mb-2">{reason.title}</h3>
                <p className="text-gray-600">{reason.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};